import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import size from 'lodash/size';
import isArray from 'lodash/isArray';
import useDriversData, {
  useAssignDrivers, useSetPrimaryDriver
} from '../../hooks/react-query/useDrivers';
import { PageTitle } from '../../components/ui';
import DriverCard from '../../components/drivers/driverCard';
import Footer from '../../components/cars/footer';
import DriverOverView from '../../components/drivers/driverOverView';
import AssignCarView from '../../components/drivers/assignCarView';
import SuccessPage from '../../components/cars/successPage';
import ToolBar from '../../components/drivers/toolBar';
import { getSearchResult } from '../../utils/validations';
import { LeftArrow } from '../../icons';
import ImportDrivers from './importDrivers';
import Container from '../../components/elements/container';
import { CardListSkeletion } from '../../components/elements/skeletions';
import DriverMobileViewTitle from '../../components/drivers/driverMobileViewTitle';
import EditDriverView from '../../components/drivers/editDriverView';
import { toast } from '../../components/ui/Toast/useToast';
import { imageStudioBaseUrl, QUERY_KEYS } from '../../config/constants';
import { queryClient } from '../../utils/queryClient';
import { Checkbox } from '../../components/ui';
import { getDriversByPlateNumberFn } from '../../transactions/drivers/drivers';
import { useQuery } from "@tanstack/react-query";
import Loader from "../../components/elements/loader";

const Drivers = () => {
  const navigate = useNavigate();

  const { CARS, ASSIGN_DRIVERS, DRIVERS} = QUERY_KEYS;
  const [primary, setPrimary] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isAssignedView, setAssignedView] = useState(false);
  const [isExpended, setViewState] = useState(false);
  const { data: driverData, isLoading: isDriverListLoading } = useDriversData();
  const [plateNumber, setPlatNumber] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [showSuccessView, setSuccessView] = useState(false);
  const [searchTerm, setSearch] = useState('');
  const [showMultipleDriversView, setMultipleDriversView] = useState(false); //

  const { mutate: assignDriver, isLoading: isLoadingAssignDriver } =
    useAssignDrivers();

  let { data: driverList } = driverData || {};

  // ============ NEW =================
  const { mutate: setPrimaryDriver, isLoading: isSettingPrimaryLoading } = useSetPrimaryDriver();

  const { data: assignedDriversList , isLoading: driversListLoading} = useQuery({
          queryKey: ['driversListPerCar', plateNumber?.plateno],
            queryFn: () => getDriversByPlateNumberFn(plateNumber?.plateno),
            staleTime: Infinity,
            cacheTime: Infinity,
            refetchOnWindowFocus: false,
            enabled: true,
            onSuccess: (data) => {},
        });

  // ============ NEW =================

  // use memo
  driverList = searchTerm
    ? getSearchResult(driverList, searchTerm)
    : driverList;

  const handleCardClick = (data) => {
    setSelectedDriver(() => data);
  };

  const handleAssignCar = () => {
    setAssignedView(true);
  };

  const handleAddNewDriverClick = () => {};

  const handleBackClick = () => {
    setAssignedView(false);
  };

  const handleCarSelect = (item) => {
    // ============ NEW =================
    if(!!plateNumber) {
      queryClient.invalidateQueries({ queryKey: ['driversListPerCar', plateNumber.plateno] });
    }
    // ============ NEW =================
    setPlatNumber(item);
  };

  const handleAssignClick = () => {
    assignDriver(
      { plateno: plateNumber.plateno, id: selectedDriver.id },
      {
        onSuccess: (response) => {
          if (response?.data && response?.data?.status === 'fail') {
            if (response.exceptions) {
              if (size(response.exceptions) > 0) {
                const exceptionsArray = isArray(response.exceptions);
                const message = exceptionsArray
                  ? response.exceptions.slice(-1)
                  : 'Παρουσιάστηκε κάποιο πρόβλημα';
                toast({
                  variant: 'destructive',
                  description: message || 'Παρουσιάστηκε κάποιο πρόβλημα',
                });
              }
            }
            setPrimary(false);
            setOpenModal(false);
          } else {
            queryClient.invalidateQueries({
              queryKey:[CARS],
              exact: false,
            })
            queryClient.invalidateQueries({ 
              queryKey: ['driversListPerCar', plateNumber] 
            });
            queryClient.invalidateQueries({
                queryKey: [DRIVERS, plateNumber.plateno],
              });
            queryClient.invalidateQueries({
              queryKey:[ASSIGN_DRIVERS, plateNumber.plateno],
            })
            setOpenModal(false);
            setSuccessView(true);
            setAssignedView(false);
            if(primary) {
              setPrimaryDriver(
                { userId: selectedDriver.id, plateno: plateNumber.plateno },
                {
                  onSuccess: () => {
                    if (response?.data && response?.data?.status === 'fail') {
                      if (response.exceptions) {
                        if (size(response.exceptions) > 0) {
                          const exceptionsArray = isArray(response.exceptions);
                          const message = exceptionsArray
                            ? response.exceptions.slice(-1)
                            : 'Παρουσιάστηκε κάποιο πρόβλημα';
                          toast({
                            variant: 'destructive',
                            description: message || 'Παρουσιάστηκε κάποιο πρόβλημα',
                          });
                        }
                      }
                      setPrimary(false);
                      setOpenModal(false);
                    } else {
                        queryClient.invalidateQueries({ 
                          queryKey: ['driversListPerCar', plateNumber] 
                        });
                        queryClient.invalidateQueries({
                          queryKey:[ASSIGN_DRIVERS, plateNumber.plateno],
                        })
                    setPrimary(false);
                    setOpenModal(false);
                    setSuccessView(true);
                    setAssignedView(false);
                    setViewState(false);
                  }
                  },
                }
              );
            }else{
              setPrimary(false);
              setOpenModal(false);
              setSuccessView(true);
              setAssignedView(false);
              setViewState(false);
            } 
          }
        },
      }
    );
  };

  const handleAssignNewCarClick = () => {
    setSuccessView(false);
  };

  const handleAssignCarView = () => {
    setPlatNumber(null);
    setSuccessView(false);
    setAssignedView(true);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setSelectedDriver(null);
  };

  if (showMultipleDriversView) {
    return (
      <ImportDrivers
        handleBackClick={() => {
          isExpended && setViewState(false);
          setMultipleDriversView(false);
        }}
        isFromDrivers={true}
      />
    );
  }

  const driverListLength = driverList ? driverList.length : 0;

  return (
    <>
      <Container>
        {!isAssignedView && !showSuccessView ? (
          <div className="flex flex-col lg:gap-5 gap-2">
            <PageTitle
              title={
                <div className="flex items-center max-xl:justify-between">
                  <button
                    className="p-2"
                    onClick={() => navigate('/dashboard')}
                  >
                    <LeftArrow width={24} height={24} />
                  </button>
                  <h2 className="max-xl:hidden">My Drivers</h2>
                  <h3 className="font-[700] max-lg:hidden xl:hidden">
                    My Drivers
                  </h3>
                  <h2 className="font-[700] lg:hidden">My Drivers</h2>
                  <DriverMobileViewTitle
                    handleAddMultipleDrivers={() =>
                      setMultipleDriversView(true)
                    }
                  />
                </div>
              }
              placeholder="Αναζήτηση"
              searchTerm={searchTerm}
              endComponent={
                <ToolBar
                  showMobileView={false}
                  handleAddMultipleDrivers={() => setMultipleDriversView(true)}
                  showExport={driverListLength}
                />
              }
              handleAddClick={handleAddNewDriverClick}
              handleSearch={handleSearch}
            />
            <div className="grid lg:grid-cols-4 gap-4">
              <ul
                className={`col-span-3 grid ${
                  driverListLength && 'lg:grid-cols-3'
                } gap-3 overflow-y-auto lg:pe-3.5 max-h-[70vh] h-fit overflow-auto scrollbar`}
              >
                {isDriverListLoading ? (
                  <CardListSkeletion />
                ) : driverListLength ? (
                  driverList?.map((item) => {
                    return (
                      <DriverCard
                        driverDetails={item}
                        selectedDriver={selectedDriver}
                        handleCardClick={(e) => handleCardClick(item)}
                        key={item.id}
                      />
                    );
                  })
                ) : (
                  <li className="flex w-full items-center justify-center">
                    Δεν υπάρχουν διαθέσιμα δεδομένα.
                  </li>
                )}
              </ul>
              <section
                className={`max-lg:hidden w-full`}
              >
                <DriverOverView
                  isExpended={isExpended}
                  selectedDriver={selectedDriver}
                  handleViewState={() => setViewState(false)}
                  handleAssignCar={handleAssignCar}
                  handleSelectedDriver={(values) => {
                    setSelectedDriver(values);
                  }}
                />
              </section>
            </div>
          </div>
        ) : showSuccessView ? (
          <SuccessPage
            backButtonText="Επιστροφή στο προφίλ οδηγού"
            redirectButtonText="Προσθήκη νέου Αυτοκινήτου"
            handleAssignClick={handleAssignCarView}
            handleBackClick={handleAssignNewCarClick}
            message={
              <div className="text-body flex flex-col items-center gap-2">
                Το {plateNumber.name} έχει προστεθεί επιτυχώς στον/στην{' '}
                {selectedDriver?.firstName} {selectedDriver?.lastName}.
                <img
                  className="lg:hidden"
                  alt={plateNumber.name}
                  src={`${imageStudioBaseUrl}&&make=${
                    plateNumber.name.split(' ')[0]
                  }&modelFamily=${
                    plateNumber.name.split(' ')[1]
                  }&modelVariant=${
                    plateNumber.name.split(' ')[1]
                  }&powerTrain=hybrid&trim=eu&zoomType=fullScreen&width=400&angle=28`}
                />
              </div>
            }
          />
        ) : (
          <AssignCarView
            selectedDriver={selectedDriver}
            handleCarSelect={handleCarSelect}
            handleBackClick={handleBackClick}
          />
        )}
      </Container>
      {isAssignedView && (
        <Footer
          title="Προσθήκη Αυτοκινήτου"
          disabled={!plateNumber}
          openModal={openModal}
          setOpenModal={setOpenModal}
          handleOkClick={handleAssignClick}
          modalTitle="Προσθήκη"
          isLoading={isLoadingAssignDriver || isDriverListLoading}
          message={
            isDriverListLoading ? <Loader className="fill-primary" /> :
            <div className='flex flex-col items-center gap-2'>
              <p>
              Είσαι σίγουρος ότι θέλεις να προσθέσεις το{' '}
              <b>{plateNumber && plateNumber.name} </b> στον/στην{' '}
              <b>
                {selectedDriver?.firstName} {selectedDriver?.lastName}
              </b>
              ;
            </p>
            {/* ============ NEW ================= */}
            {assignedDriversList?.data.length > 0 ?
              <div className='flex gap-2'>
                <Checkbox checked={primary} onCheckedChange={(value) => { setPrimary(value);}}/>
                <p className='text-sm'>Ορισμός ως κύριος οδηγός.</p>
                </div>
              : <p>Θα οριστεί αυτόματα και ως κύριος οδηγός. Στη συνέχεια, μπορείς να αλλάξεις τον κύριο οδηγό οποιαδήποτε στιγμή.</p>
            }
            {/* ============ NEW ================= */}
            </div>
          }
        />
      )}

      {selectedDriver && !isAssignedView && !showSuccessView && (
        <div className="lg:hidden fixed bottom-0 w-full h-[94px] bg-white flex flex-col gap-3 p-3">
          <EditDriverView
            setSelectedDriver={setSelectedDriver}
            selectedDriver={selectedDriver}
            handleAddMultipleDrivers={() => setMultipleDriversView(true)}
            handleAssignCar={handleAssignCar}
          />
        </div>
      )}
    </>
  );
};

export default Drivers;
